export default [
    {
        "ID": 1,
        "LOCATION": "黄山市",
        "NAME": "徽墨",
        "CONTENT": "原产地黄山、宣城，有落纸如漆，色泽黑润，经久不褪，纸笔不胶，香味浓郁，丰肌腻理等特点，素有拈来轻、磨来清、嗅来馨、坚如玉、研无声、一点如漆、万载存真的美誉。",
        "IMGURL":require("@/assets/landmark/sign-1.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 2,
        "LOCATION": "黄山市",
        "NAME": "歙砚",
        "CONTENT": "原产地古歙州，包括歙县、休宁、祁门、黟县、婺源等县，以婺源与歙县交界处的龙尾山（罗纹山）下溪涧为最优，中国四大名砚之一。有发墨益毫、滑不拒笔、涩不滞笔的特点，受到历代书法家的称赞。",
        "IMGURL":require("@/assets/landmark/sign-2.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 3,
        "LOCATION": "黄山市",
        "NAME": "黄山毛峰",
        "CONTENT": "原产地黄山，中国传统名茶，中国历史名茶之一。形如雀舌，匀齐壮实，锋毫显露，色显嫩绿泛象牙色，芽叶金黄，香气馥郁持久，汤色嫩黄绿，清澈明亮，滋味鲜醇甘爽。典型品质特征嫩绿象牙色，醇鲜甘甜味。",
        "IMGURL":require("@/assets/landmark/sign-3.jpg"),
        "USENUMBER": "63"
    },
    {
        "ID": 4,
        "LOCATION": "黄山区",
        "NAME": "太平猴魁",
        "CONTENT": "原产地黄山区太平乡，中国传统名茶，中国历史名茶之一，为绿茶类尖茶之极品。其外形两叶抱芽，扁平挺直，自然舒展，白毫隐伏，有“猴魁两头尖，不散不翘不卷边”的美名。",
        "IMGURL":require("@/assets/landmark/sign-4.jpg"),
        "USENUMBER": "42"
    },
    {
        "ID": 5,
        "LOCATION": "歙县",
        "NAME": "黄山贡菊",
        "CONTENT": "原产地歙县，也叫徽州贡菊或贡菊，为全国四大名菊之一。既是大宗名贵的地道药材，又是茗饮佳品，因其“色白、蒂绿、花心小、质柔软、气芳香、均匀不散朵，开水冲泡汤清、味甘”的品质特点被誉为“菊中之冠”。",
        "IMGURL":require("@/assets/landmark/sign-5.jpg"),
        "USENUMBER": "24"
    },
    {
        "ID": 6,
        "LOCATION": "歙县",
        "NAME": "黄山白茶",
        "CONTENT": "原产地歙县，古称甘白香，是以黄山茶树群体种的白化变异植株，以及以此为母本繁育的综合性状稳定的无性系茶树新梢为原料，采用绿茶加工工艺制作而成。其色白形美，极富观赏价值。富含氨基酸等多种微量元素，冲泡后似凤羽有兰花香，茶气氤氲，汤色清澈，满口甜香。",
        "IMGURL":require("@/assets/landmark/sign-6.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 7,
        "LOCATION": "歙县",
        "NAME": "三潭枇杷",
        "CONTENT": "原产地歙县，新安江流域的“漳潭、绵潭、瀹潭”沿线，其果大肉厚、柔软多汁、酸甜可口，素有“天上瑶池蟠桃，地下三潭枇杷”之美誉。",
        "IMGURL":require("@/assets/landmark/sign-7.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 8,
        "LOCATION": "休宁县",
        "NAME": "五城茶干",
        "CONTENT": "原产地休宁，徽州地区传统特产小吃，以配料讲究、制作精细、色香味美而著称；始创于南宋末年，工艺成熟于元代，隆盛于清。咸淡相宜，质纯味鲜，柔韧香醇，营养丰富。",
        "IMGURL":require("@/assets/landmark/sign-8.jpg"),
        "USENUMBER": "3"
    },
    {
        "ID": 9,
        "LOCATION": "休宁县",
        "NAME": "松萝茶",
        "CONTENT": "原产地休宁县松萝山，徽州历史传统名茶的领军茶，始于唐，兴于明，盛于清，始创炒青制作技术，被誉为“炒青始祖”。制作工艺领先，具有独特药效，人称“绿色金子”；其品饮形式创新，瀹饮法一直流传至今。",
        "IMGURL":require("@/assets/landmark/sign-9.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 10,
        "LOCATION": "休宁县",
        "NAME": "万安罗盘",
        "CONTENT": "原产地休宁县万安镇万安老街，广泛运用于天文、地理、军事、航海和占卜，以及居屋、墓葬选址的重要仪器，是古代汉族劳动人民的四大发明之一指南针的沿续和发展，是在指南针的基础上发展而来的传统民俗工艺品。",
        "IMGURL":require("@/assets/landmark/sign-10.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 11,
        "LOCATION": "休宁县",
        "NAME": "五城米酒",
        "CONTENT": "原产地休宁县五城镇，外观橙黄色至琥珀色，清澈透明，有光泽，不浑浊，无沉淀，香气浓郁，具有独特的纯正、自然的醇香，无异味，口感柔和醇厚，酒体丰满，鲜爽，甜润爽口，醇厚甘绵，富含多种维生素、氨基酸等营养成分。",
        "IMGURL":require("@/assets/landmark/sign-11.jpg"),
        "USENUMBER": "4"
    },
    {
        "ID": 12,
        "LOCATION": "祁门县",
        "NAME": "安茶",
        "CONTENT": "原产地祁门，中国历史传统工艺名茶，明末清初由“软枝茶”发展而来。半发酵的紧压茶，以箬叶包裹竹篓盛装蒸压制成，属黑茶类。外形紧结匀齐，色黑褐尚润，香气高长有槟榔香，滋味鲜爽中含香，汤色橙黄明亮，叶底黄褐尚亮，具有茶性温凉，以陈为贵，陈而不霉，陈而不烂，越陈越醇的特有品格。",
        "IMGURL":require("@/assets/landmark/sign-12.jpg"),
        "USENUMBER": "7"
    },
    {
        "ID": 13,
        "LOCATION": "六安市",
        "NAME": "六安瓜片",
        "CONTENT": "原产地六安市大别山区，是传统历史名茶，中国十大名茶之一，为特种绿茶，是唯一无芽无梗由单片生叶制成，单片形体，形似瓜子，叶片自然平展边缘微翘，色泽宝绿有霜；茶汤黄绿，滋味醇厚，粟香或兰香型，香气持久。",
        "IMGURL":require("@/assets/landmark/sign-13.jpg"),
        "USENUMBER": "63"
    },
    {
        "ID": 14,
        "LOCATION": "霍山县",
        "NAME": "霍山黄芽",
        "CONTENT": "原产地霍山，中国历史名茶之一，外形挺直微展、形似雀舌，自然舒展，黄绿披毫。汤色黄绿明亮，香气清香持久，滋味鲜醇回甘，叶底嫩黄鲜亮，最突出的感官特征是“三黄”（色黄、汤黄、叶底黄）。",
        "IMGURL":require("@/assets/landmark/sign-14.jpg"),
        "USENUMBER": "17"
    },
    {
        "ID": 15,
        "LOCATION": "霍山县",
        "NAME": "漫水河百合",
        "CONTENT": "原产地霍山，为百合科卷丹百合的变种，属三倍体，含有丰富的秋水仙碱、百合苷、果胶和磷脂类物质以及多种营养物质、矿物质、维生素等，具有养阴润肺止咳，清心安神功用，有镇咳、平喘、祛痰、抗疲劳、镇静、催眠、提高免疫力，升高外围白细胞等药理作用。",
        "IMGURL":require("@/assets/landmark/sign-15.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 16,
        "LOCATION": "霍山县",
        "NAME": "霍山石斛",
        "CONTENT": "原产地霍山，兰科石斛属植物，是我国特有的一个石斛品种，多野生于温暖湿润的阴坡、半阴坡微酸性岩层峭壁上或林下岩石上。是历代本草中明确记载的四种药用石斛之一，以其味甘、粘质厚的上乘品质成为石斛中的极品，备受历代医家推崇。",
        "IMGURL":require("@/assets/landmark/sign-16.jpg"),
        "USENUMBER": "82"
    },
    {
        "ID": 17,
        "LOCATION": "霍山县",
        "NAME": "迎驾贡酒",
        "CONTENT": "原产地霍山，浓香型白酒，采用传统酿造技艺，精选长城以南优质高粱、沿淮两岸的大米、糯米、小麦、玉米为原料，酿造和勾调全部选用竹根活水、中国好水——剐水，晶莹剔透、绵甜爽口，具备“绵、甜、醇、柔、香”的口感特征。",
        "IMGURL":require("@/assets/landmark/sign-17.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 18,
        "LOCATION": "霍山县",
        "NAME": "霍山灵芝",
        "CONTENT": "原产地霍山，又称赤芝、红芝、木灵芝、菌灵芝、灵芝草，是一种非常名贵的药用真菌，系多孔菌科灵芝属，是吉祥、富贵、美好、长寿的象征。含有多种生理活性物质，能够调节、增强人体免疫力，对神经衰弱、风湿性关节炎，冠心病、高血压、肝炎、糖尿病、肿瘤等有良好的协同治疗作用。",
        "IMGURL":require("@/assets/landmark/sign-18.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 19,
        "LOCATION": "霍山县",
        "NAME": "霍山黄大茶",
        "CONTENT": "原产地霍山，中国历史名茶之一，黄茶类的典型代表之一，外形梗壮叶肥，叶片成条，梗叶相连形似钓鱼钩，梗叶金黄显褐，色泽油润，味浓厚耐泡，俗称“古铜色，高火香，叶大能包盐，梗长能撑船。”",
        "IMGURL":require("@/assets/landmark/sign-19.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 20,
        "LOCATION": "霍邱县",
        "NAME": "霍邱柳编",
        "CONTENT": "原产地霍邱县临淮岗乡，历史悠久，品种由传统工艺几十种的家庭日常用具发展到精编、细编、透花编、套色编、染色编、混合编(柳竹混、柳麻混、柳木混、柳草木混)等几十种编织技巧。",
        "IMGURL":require("@/assets/landmark/sign-20.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 21,
        "LOCATION": "霍邱县",
        "NAME": "临水酒",
        "CONTENT": "原产地霍邱县临水镇，采用优质人工窖泥，以高粱为原料，以小麦、大麦、豌豆踩制的大曲为糖化发酵剂，泥窖发酵,用临水地下优质矿泉水精心酿制而成，具有洞藏兼香的产品特性。",
        "IMGURL":require("@/assets/landmark/sign-21.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 22,
        "LOCATION": "金寨县",
        "NAME": "金寨猕猴桃",
        "CONTENT": "原产地金寨，历史悠久，距今已有三千多年，多为野生，可食用的主要有三种：中华猕猴桃、软枣猕猴桃、葛枣猕猴桃。富含维生素、矿物质和18种氨基酸，被誉为“水果之王”。",
        "IMGURL":require("@/assets/landmark/sign-22.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 23,
        "LOCATION": "舒城县",
        "NAME": "舒城小兰花",
        "CONTENT": "原产地舒城，是安徽十大历史名茶之一，采用一芽一叶至一芽二、三叶的鲜叶原料，以传统手工竹丝把炒制和木炭火烘焙等独特工具和工艺精制而成。特点是“三兰三绿”，即兰花形、兰草色、兰花香，干茶翠绿、茶汤碧绿、叶底嫩绿。",
        "IMGURL":require("@/assets/landmark/sign-23.jpg"),
        "USENUMBER": "5"
    },
    {
        "ID": 24,
        "LOCATION": "安庆市",
        "NAME": "胡玉美蚕豆辣酱",
        "CONTENT": "原产地安庆市大观区，采用熟料制曲、天然日晒夜露发酵工艺，运用多菌种发酵技术，精工酿制而成。该产品具有鲜、香、咸、甜、辣等多种口味。产品色泽鲜艳、酯香纯正，味道鲜美、醇厚微辣，豆瓣口触平滑、入口化渣，富含人体必需的氨基酸和各种B族维生素，能增强食欲，促进消化，是烹饪和佐餐佳品。",
        "IMGURL":require("@/assets/landmark/sign-24.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 25,
        "LOCATION": "潜山市",
        "NAME": "天柱山瓜蒌籽",
        "CONTENT": "原产地潜山，外观呈浅棕色或棕褐色、双边微凸、子粒饱满。采用传统工艺加工后，入口咸（甜），破壳后子仁鲜美，润脆可口，香、咸（甜）纯正，具备壳薄、仁肥、质脆、香浓、口感好的特色。",
        "IMGURL":require("@/assets/landmark/sign-25.jpg"),
        "USENUMBER": "8"
    },
    {
        "ID": 26,
        "LOCATION": "潜山市",
        "NAME": "舒席",
        "CONTENT": "原产地潜山市王河镇，古称“竹簟”，具有色泽鲜艳、细薄柔滑、坚韧耐磨、折卷不断、吸水性强、凉爽消汗、越用越凉、不腐不蚀、携带极便等质量特色。",
        "IMGURL":require("@/assets/landmark/sign-26.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 27,
        "LOCATION": "岳西县",
        "NAME": "岳西茭白",
        "CONTENT": "原产地岳西，茭体粗细均匀，肉茭个大饱满，外形美观，色白光润脆嫩，质地紧密，口味纯正，品质优良。",
        "IMGURL":require("@/assets/landmark/sign-27.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 28,
        "LOCATION": "岳西县",
        "NAME": "岳西翠兰",
        "CONTENT": "原产地岳西，全国名茶，创制于1985年。外形芽叶肥壮、翠绿鲜润；汤色绿亮；滋味鲜醇甘爽；香气清香带兰；叶底嫩匀绿亮。其独特的品质特征：翠绿鲜活，兰香入味。",
        "IMGURL":require("@/assets/landmark/sign-28.jpg"),
        "USENUMBER": "4"
    },
    {
        "ID": 29,
        "LOCATION": "岳西县",
        "NAME": "岳西桑皮纸",
        "CONTENT": "原产地岳西，其制作技艺保留了中国传统造纸技术的精髓，被称为人类纸业的“活化石”。柔嫩、防虫、拉力强、不褪色、吸水力强、耐折叠。纸张呈米白色，纤维细密，纹理清晰，光而不滑，墨韵层次鲜明，手感润柔坚韧，纸边不剪裁，保留了桑皮纤维的自然状态，纸面平整，无褶折及其它附着物。",
        "IMGURL":require("@/assets/landmark/sign-29.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 30,
        "LOCATION": "岳西县",
        "NAME": "岳西黑猪",
        "CONTENT": "原产地岳西，源自淮猪，具有毛黑浓密、短小精干、皮厚多褶、骨细髓满、肉面干爽、肉味鲜香、肉质筋道等显著质量特色，古往今来素有“一家食肉满村香”的美誉。",
        "IMGURL":require("@/assets/landmark/sign-30.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 31,
        "LOCATION": "宿松县",
        "NAME": "黄湖大闸蟹",
        "CONTENT": "原产地宿松，属正宗长江中华绒螯蟹品系。肉质细嫩，味道鲜美，营养价值很高，素有“青壳白板、金爪黄毛、个大体肥、营养丰富”之美誉。",
        "IMGURL":require("@/assets/landmark/sign-31.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 32,
        "LOCATION": "太湖县",
        "NAME": "天华谷尖",
        "CONTENT": "又名南阳谷尖,原产地太湖，形似稻谷，滋味鲜爽、醇厚，色泽翠绿，清香持久，汤色碧绿，滋味鲜爽，叶底匀整明亮。",
        "IMGURL":require("@/assets/landmark/sign-32.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 33,
        "LOCATION": "怀宁县",
        "NAME": "怀宁贡糕",
        "CONTENT": "原产地怀宁，采用本地产的糯米和广西优质白砂糖为主要原材料，再配以芝麻、核桃仁、桂花和小磨麻油等辅料，经二十多道工序精细加工而成。特点：洁白柔软、香甜可口、形状多样、可赏可食，俗称：薄如纸、捻如牌、白如雪、燃如烛。",
        "IMGURL":require("@/assets/landmark/sign-33.jpg"),
        "USENUMBER": "11"
    },
    {
        "ID": 34,
        "LOCATION": "怀宁县",
        "NAME": "龙池香尖",
        "CONTENT": "原产地怀宁县浅山区龙池尖，是皖西南地区传统名茶，其制作始于宋代。具有芽叶壮实、形扁似矛、显露茸毫、汤色黄绿明亮、清香高郁、滋味醇爽、叶底绿明等特色。",
        "IMGURL":require("@/assets/landmark/sign-34.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 35,
        "LOCATION": "泾县",
        "NAME": "宣纸",
        "CONTENT": "原产地泾县，光而不滑、质地绵韧，洁白稠密，素有“轻似蝉翼白如雪，抖似细绸不闻声”之称，最能体现书画艺术魅力的载体之一，是“纸中之王”“国之瑰宝”。因其不蛀不腐，水线清晰、层次分明，享有“纸寿千年、墨韵万变”的美名，被誉为“文房之宝、艺术之光”。",
        "IMGURL":require("@/assets/landmark/sign-35.jpg"),
        "USENUMBER": "15"
    },
    {
        "ID": 36,
        "LOCATION": "宁国市",
        "NAME": "宁国山核桃",
        "CONTENT": "原产地宁国市天目山北麓，籽大壳薄，核仁肥厚、含油量高，色味香美、果仁清脆可口，具有润肺滋养、益胃养颜、乌须黑发之功效。",
        "IMGURL":require("@/assets/landmark/sign-36.jpg"),
        "USENUMBER": "9"
    },
    {
        "ID": 37,
        "LOCATION": "宁国市",
        "NAME": "宁国笋干",
        "CONTENT": "原产地宁国，是竹笋经蒸煮、烘烤制成的一种干菜，具有味鲜色美、脆香爽口、色泽青绿黄亮、香气馥郁、鲜嫩可口、营养丰富、烹调方便、耐贮藏、易保存、易包装运输等优点，被誉为“山菜之王”。",
        "IMGURL":require("@/assets/landmark/sign-37.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 38,
        "LOCATION": "宣州区",
        "NAME": "小窖宣酒",
        "CONTENT": "原产地宣城，采用小窖工艺酿造的原酒精心匠制而成。其浓香特征为陈香幽雅、窖香舒适、绵甜柔顺、酒体圆润、余味爽净，兼含芝香特征，醇厚饱满、细腻柔顺、回味悠长、空杯留香持久。",
        "IMGURL":require("@/assets/landmark/sign-38.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 39,
        "LOCATION": "宣州区",
        "NAME": "宣城木榨油",
        "CONTENT": "原产地宣城市宣州区，采用传统古法木榨油工艺，能最大程度保留油的原香和营养。色泽枣红、澄清透亮,不浑浊。具有菜籽油固有的气味和滋味，香味浓郁持久，口感纯正。",
        "IMGURL":require("@/assets/landmark/sign-39.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 40,
        "LOCATION": "郎溪县",
        "NAME": "南丰黄酒",
        "CONTENT": "原产地郎溪县郎川河流域，以糯米、小麦、粳米为原料，用传统工艺精心酿制而成。清亮透明，呈琥珀色光泽，具有醇香特别、口感醇和、鲜甜爽口及酒体协调等特点。",
        "IMGURL":require("@/assets/landmark/sign-40.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 41,
        "LOCATION": "绩溪县",
        "NAME": "徽墨",
        "CONTENT": "原产地黄山、宣城，有落纸如漆，色泽黑润，经久不褪，纸笔不胶，香味浓郁，丰肌腻理等特点，素有拈来轻、磨来清、嗅来馨、坚如玉、研无声、一点如漆、万载存真的美誉。",
        "IMGURL":require("@/assets/landmark/sign-1.jpg"),
        "USENUMBER": null
    },
	{
        "ID": 42,
        "LOCATION": "绩溪县",
        "NAME": "歙砚",
        "CONTENT": "原产地古歙州，包括歙县、休宁、祁门、黟县、婺源等县，以婺源与歙县交界处的龙尾山（罗纹山）下溪涧为最优，中国四大名砚之一。有发墨益毫、滑不拒笔、涩不滞笔的特点，受到历代书法家的称赞。",
        "IMGURL":require("@/assets/landmark/sign-2.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 43,
        "LOCATION": "滁州市",
        "NAME": "滁菊",
        "CONTENT": "原产地滁州，是菊花中花瓣最为紧密的一种，名列中国“四大药菊”之首，安徽省四大著名道地药材，可消热解毒、舒筋活血，护肝明目，增强人体免疫功能。对高血压、冠心病、动脉硬化疗效显著。清朝光绪元年被朝廷纳为贡品，故有“滁州贡菊”之称。",
        "IMGURL":require("@/assets/landmark/sign-43.jpg"),
        "USENUMBER": "6"
    },
    {
        "ID": 44,
        "LOCATION": "明光市",
        "NAME": "明绿御酒",
        "CONTENT": "原产地明光，主要原料为驰名中外的明光绿豆，沿用南宋以来独有的酿造工艺和全手工酿造技术酿制而成。其酒质“甘美醇厚、澄碧清冽、豆香幽雅、风味独特”。",
		"IMGURL":require("@/assets/landmark/sign-44.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 45,
        "LOCATION": "明光市",
        "NAME": "女山湖大闸蟹",
        "CONTENT": "原产地明光，壳青肚白、金爪黄毛，体大肉肥，膏丰黄满，味道鲜美。因“脂肥膏满、润甜清香”而享誉四方。",
		"IMGURL":require("@/assets/landmark/sign-45.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 46,
        "LOCATION": "明光市",
        "NAME": "明光绿豆",
        "CONTENT": "原产地明光市明东、石坝、涧溪、卞庄、管店及横山等乡镇，具有色泽碧绿、粒大皮薄、汤清易烂、味香爽口等特点和清热解毒、抗过敏等药用。",
		"IMGURL":require("@/assets/landmark/sign-46.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 47,
        "LOCATION": "来安县",
        "NAME": "来安花红",
        "CONTENT": "原产地来安，小巧玲珑，形似苹果，色泽青黄红晕，外观艳美，皮薄肉脆，汁多渣少，酸甜爽口，香味浓郁，富含多种维生素和对人体有益的微量元素，有较高的营养价值，具有解渴、防暑、健胃、生津、去火、防痢止泻等作用。",
		"IMGURL":require("@/assets/landmark/sign-47.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 48,
        "LOCATION": "天长市",
        "NAME": "龙岗芡实",
        "CONTENT": "原产地天长，又名龙岗鸡头，味甘而香，富含淀粉、糖粉、脂肪、蛋白质和多种维生素，对治疗遗精、淋浊、白带、小便不禁、大便泄泻等症具有良好的效果。",
		"IMGURL":require("@/assets/landmark/sign-48.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 49,
        "LOCATION": "亳州市",
        "NAME": "亳白芍",
        "CONTENT": "原产地亳州，外观呈圆柱形，平直或稍弯曲，两端平截，长5厘米至18厘米，直径1.0厘米至2.5厘米，表面类白色或淡红棕色，质坚实不易折断，断面较平坦。",
		"IMGURL":require("@/assets/landmark/sign-49.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 50,
        "LOCATION": "涡阳县",
        "NAME": "涡阳苔干",
        "CONTENT": "原产地涡阳，又名“贡菜”，是一种由莴苣状的植物加工成的半干品条状蔬菜。新鲜苔干去皮后翠绿剔透，晾晒脱水后呈青绿色，古时称之为“翡翠绿”。其特点：翠绿鲜嫩、响脆爽口、甜淡清腻、爽口提神、营养丰富，具有清热、明目、解毒、利五脏、通经脉等功效，素有绿色食品、天然保健食品之称。",
		"IMGURL":require("@/assets/landmark/sign-50.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 51,
        "LOCATION": "涡阳县",
        "NAME": "高炉家酒",
        "CONTENT": "原产地涡阳县高炉镇，是在浓香型白酒传统酿造技艺的基础上又采用双轮发酵工艺而成，色泽微黄清亮透明，口味醇厚丰满，绵甜柔顺，回味怡畅。末代清帝溥仪曾写下“汉三杰闻香下马，高炉酒十里飘香”的诗句。",
		"IMGURL":require("@/assets/landmark/sign-51.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 52,
        "LOCATION": "谯城区",
        "NAME": "古井贡酒",
        "CONTENT": "原产地亳州，始于建安元年（196年），曹操将家乡产的“九酝春酒”和酿造方法进献给汉献帝刘协。是中国老八大名酒，大曲浓香型白酒，有“酒中牡丹”之称。具有“色清如水晶、香纯似幽兰、入口甘美醇和、回味经久不息”的特点。",
		"IMGURL":require("@/assets/landmark/sign-52.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 53,
        "LOCATION": "庐江县",
        "NAME": "黄陂湖大闸蟹",
        "CONTENT": "原产地庐江，蟹肉纤维长，肉质细腻鲜甜，营养丰富、风味独特，素以“青壳背厚、白肚金爪、个大膏腴、黄满味美”而著称。",
		"IMGURL":require("@/assets/landmark/sign-53.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 54,
        "LOCATION": "肥西县",
        "NAME": "三河米酒",
        "CONTENT": "原产地肥西三河镇，用纯糯米进行天然发酵酿制而成，色泽橙红清亮，有光泽；味鲜美、醇厚、柔和、爽口、口味绵长，经过封缸后富含大量益生菌和氨基酸，药用价值较高。",
		"IMGURL":require("@/assets/landmark/sign-54.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 55,
        "LOCATION": "肥西县",
        "NAME": "丰乐酱干",
        "CONTENT": "原产地肥西，采用丰乐河水手工制作，色泽油亮，色、香、味俱佳，制作过程完全遵循传统手工艺、做工精细，具有色彩纯正、香味悠长、口感细腻、富有弹性、回味清香的特点。",
		"IMGURL":require("@/assets/landmark/sign-55.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 56,
        "LOCATION": "淮北市",
        "NAME": "口子窖酒",
        "CONTENT": "原产地淮北，传承口子千百年“大蒸大回”工艺，以优质高粱、大米、糯米、小麦、大麦、豌豆为原料，采用独特的菊花心曲、高温香曲、超高温香曲为糖化发酵生香剂，经高温堆积润料和续渣混蒸老五甑工艺，多轮固态发酵，缓慢蒸馏，量质摘酒，分级窖藏，再经国家白酒大师精心勾调陈酿而成。具有入口窖香馥郁典雅、落喉醇和绵甜净爽、回味醇厚余味幽长，层次丰富、诸香协调、挂杯持久、空杯留香的独特风格，为中国兼香型白酒的典型代表。",
		"IMGURL":require("@/assets/landmark/sign-56.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 57,
        "LOCATION": "烈山区",
        "NAME": "塔山石榴",
        "CONTENT": "原产地淮北市烈山区榴园社区，种植迄今已有千年历史，以粒大、核软、皮薄、出汁率和可溶性固形物含量高而著称。",
		"IMGURL":require("@/assets/landmark/sign-57.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 58,
        "LOCATION": "杜集区",
        "NAME": "段园葡萄",
        "CONTENT": "原产地淮北市杜集区，种植源于清代，距今近300余年历史。具有“穗大粒饱，色泽鲜艳；汁多核少，酸甜适中；清爽可口，风味淳厚；祛病健体，营养丰富”的独特品质。",
		"IMGURL":require("@/assets/landmark/sign-58.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 59,
        "LOCATION": "濉溪县",
        "NAME": "临涣酱包瓜",
        "CONTENT": "原产地淮北市临涣镇，又称“菜中菜”，外壳是圆、嫩、鲜、脆的酱培包瓜，内瓤为“倾馅十样绵，颜色有五六”的香味浓郁的酱菜。外形似鼓，体态规格整齐，不漏馅。滋味脆嫩清香，入口清脆，咸甜适度，酱味浓郁。",
		"IMGURL":require("@/assets/landmark/sign-59.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 60,
        "LOCATION": "宿州市",
        "NAME": "砀山酥梨",
        "CONTENT": "原产地“中国梨都”砀山，属白梨系统，是白梨和沙梨的天然杂交种，以果实硕大，甘甜酥脆而驰名中外。果皮呈淡金黄色，平滑而有腊质光泽，果肉洁白如玉，酥脆爽口，浓甜如蜜，风味纯正，更兼皮薄多汁、弹指即破、入口即酥、落地无渣的特点。",
		"IMGURL":require("@/assets/landmark/sign-60.jpg"),
        "USENUMBER": "25"
    },
    {
        "ID": 61,
        "LOCATION": "埇桥区",
        "NAME": "符离集烧鸡",
        "CONTENT": "原产地宿州，位居中国四大名鸡之首，具有两千多年的制作历史，源远流长，久盛不衰，以其精湛的传统工艺、科学的现代配方、独特的美食风味，堪称中国饮食一绝。",
		"IMGURL":require("@/assets/landmark/sign-61.jpg"),
        "USENUMBER": "3"
    },
    {
        "ID": 62,
        "LOCATION": "灵璧县",
        "NAME": "灵璧石",
        "CONTENT": "原产地灵璧，滋润古朴，纹理嶙峋，色如墨玉，体态玲珑，殚奇尽怪，瘦、漏、透、皱、伛，在众多奇石中，独树一帜，遥遥领先。",
		"IMGURL":require("@/assets/landmark/sign-62.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 63,
        "LOCATION": "泗县",
        "NAME": "大路口山芋",
        "CONTENT": "原产地泗县大路口乡，口感香、甜、面、李子味浓，绵甜香糯，富含淀粉、可溶性糖、多种纤维素、氨基酸及矿物质等营养元素。",
		"IMGURL":require("@/assets/landmark/sign-63.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 64,
        "LOCATION": "萧县",
        "NAME": "萧县葡萄",
        "CONTENT": "原产地萧县，近百个品种，“玫瑰香”葡萄紫里透红，宛如珊瑚玛瑙，有穗大、粒饱、肉肥、多汁、透明、清香、食后生津等优点。“白羽”葡萄犹如水晶白玉，晶莹透明，果粒严实，皮薄汁多，既酸又甜，香郁爽口。",
		"IMGURL":require("@/assets/landmark/sign-64.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 65,
        "LOCATION": "五河县",
        "NAME": "沱湖螃蟹",
        "CONTENT": "原产地五河，青壳、白肚、金爪、褐螯，体色纯正，健壮有力。成蟹壳肉盈实，膏脂丰腴，蟹肉微甜、味鲜，蟹壳簿而脆,钙质含量高。",
		"IMGURL":require("@/assets/landmark/sign-65.jpg"),
        "USENUMBER": "5"
    },
    {
        "ID": 66,
        "LOCATION": "怀远县",
        "NAME": "怀远石榴",
        "CONTENT": "原产地怀远，栽培历史悠久，品质上佳，享有盛誉，曾作为皇家贡品，具有独特的地方特色。色泽艳丽，布满红晕，并有青翠光泽，果粒如玉琢脂凝，十分美观，以皮薄、核软、含糖量及可食率高而闻名。",
		"IMGURL":require("@/assets/landmark/sign-66.jpg"),
        "USENUMBER": "6"
    },
    {
        "ID": 67,
        "LOCATION": "怀远县",
        "NAME": "白莲坡贡米",
        "CONTENT": "原产地怀远，形体饱满，米粒呈半透明或透明，色泽青白有光泽，观之晶莹如玉，煮之能挑三层皮，有特有的米香味，饭粒表面有油光，口感绵软略粘、微甜、略有韧性，冷却后仍能保持良好口感，感觉膨松香甜爽口，曾作为进贡皇宫的御米而名扬海内外。",
		"IMGURL":require("@/assets/landmark/sign-67.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 68,
        "LOCATION": "当涂县",
        "NAME": "石臼湖螃蟹",
        "CONTENT": "原产地当涂，为中华绒螯蟹，蟹爪金黄，足毛棕红，个大肉嫩，黄多油厚，时鲜而甘厚，肉嫩而不散。",
		"IMGURL":require("@/assets/landmark/sign-68.jpg"),
        "USENUMBER": "3"
    },
    {
        "ID": 69,
        "LOCATION": "和县",
        "NAME": "和县黄金瓜",
        "CONTENT": "原产地和县历阳、乌江、香泉、西埠、善厚5镇，又名十棱黄金瓜，学名伊丽莎白厚皮甜瓜，因色泽金黄而得名。外观鲜艳夺目，香气浓郁独特，内含多种维生素及果糖，汁多味美，甘甜清脆。",
		"IMGURL":require("@/assets/landmark/sign-69.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 70,
        "LOCATION": "含山县",
        "NAME": "运漕酒（运酒）",
        "CONTENT": "原产地含山县运漕镇，微量成分复杂丰富，比例协调，具有香气馥郁、幽雅舒适，酒体醇厚丰满、柔绵甜润，诸味谐调，余味净爽怡畅之独特风格。",
		"IMGURL":require("@/assets/landmark/sign-70.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 71,
        "LOCATION": "含山县",
        "NAME": "含眉绿茶",
        "CONTENT": "原产地含山，微扁、紧秀挺直、叶面光滑、嫩绿鲜润，香气高长持久，入口鲜爽、回味甘甜，汤色明亮、碧绿清澈，叶底细嫩成朵。",
		"IMGURL":require("@/assets/landmark/sign-71.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 72,
        "LOCATION": "石台县",
        "NAME": "石台富硒茶",
        "CONTENT": "原产地石台，属于绿茶的一种。外形紧结，芽叶肥嫩、绿润；富含硒，清香高长，略带野花香；汤色黄绿、明亮，滋味鲜醇。",
		"IMGURL":require("@/assets/landmark/sign-72.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 73,
        "LOCATION": "贵池区",
        "NAME": "西山焦枣",
        "CONTENT": "原产地池州市贵池区棠溪镇西山村，贵池十三种地方土特产品之首，素有“西山焦枣，贵池之宝；色如紫晶，形似玛瑙；风味独特，国内稀少”的美誉。",
		"IMGURL":require("@/assets/landmark/sign-73.jpg"),
        "USENUMBER": "4"
    },
    {
        "ID": 74,
        "LOCATION": "青阳县",
        "NAME": "九华黄精",
        "CONTENT": "原产地青阳，属于多花黄精（姜形黄精），色泽鲜亮，口感清脆微甜有麻味，肉质饱满柔软，质地沉重，经九制九晒乌黑发亮，浓香怡人、口感香甜，营养丰富。",
		"IMGURL":require("@/assets/landmark/sign-74.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 75,
        "LOCATION": "颍州区",
        "NAME": "金种子酒",
        "CONTENT": "原产地阜阳，酿酒历史悠久，文化源远流长，与中原文明、黄淮文明一脉相承，底蕴深厚。独创物理恒温窖藏技术，首创柔和型白酒新工艺。",
		"IMGURL":require("@/assets/landmark/sign-75.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 76,
        "LOCATION": "阜南县",
        "NAME": "黄岗柳编",
        "CONTENT": "原产地阜南，历史悠久、文化底蕴深厚，杞柳种植可上溯千年，编织历史亦达500多年。黄岗柳条柔软易弯、粗细匀称、色泽高雅，通过新颖的设计，可以编织成各种朴实自然、造型美观、轻便耐用的实用工艺品。",
		"IMGURL":require("@/assets/landmark/sign-76.jpg"),
        "USENUMBER": "60"
    },
    {
        "ID": 77,
        "LOCATION": "太和县",
        "NAME": "李兴桔梗",
        "CONTENT": "原产地太和，外观黄白色、光滑，呈圆柱形，横切面呈白色或黄白色，分叉少。香气浓郁，无渣爽口，味微甜苦味少。",
		"IMGURL":require("@/assets/landmark/sign-77.jpg"),
        "USENUMBER": "2"
    },
    {
        "ID": 78,
        "LOCATION": "淮南市",
        "NAME": "八公山豆腐",
        "CONTENT": "原产地淮南市，发明于2100多年前的西汉时期，因其历史悠久，文化底蕴深厚，洁白、细腻、爽滑、鲜美而久负盛名，素有“八公山豆腐甲天下”、“中国古代第五大发明”之称。",
		"IMGURL":require("@/assets/landmark/sign-78.jpg"),
        "USENUMBER": "7"
    },
    {
        "ID": 79,
        "LOCATION": "潘集区",
        "NAME": "潘集酥瓜",
        "CONTENT": "原产地淮南市潘集区，其外形羊角形，瓜皮白绿色，瓜肉绿色，瓜瓤桔红色，含汁液量大，香甜酥脆可口，是炎夏清热解暑之佳品。",
		"IMGURL":require("@/assets/landmark/sign-79.jpg"),
        "USENUMBER": "3"
    },
    {
        "ID": 80,
        "LOCATION": "铜陵市",
        "NAME": "铜陵白姜",
        "CONTENT": "原产地铜陵市义安区、天门镇、顺安镇、东联乡、四联乡、钟鸣镇6个乡镇，系铜陵“八宝”之一，多年生草本植物，一年生栽培作物。鲜姜皮为白略呈黄色，姜块成佛手状，瓣粗肥厚。鲜嫩汁多，味辣而不呛口，具有“块大皮薄，汁多渣少，肉质脆嫩，香味浓郁”等特色。",
		"IMGURL":require("@/assets/landmark/sign-80.jpg"),
        "USENUMBER": "12"
    },
    {
        "ID": 81,
        "LOCATION": "铜陵市",
        "NAME": "凤丹",
        "CONTENT": "原产地铜陵，属江南牡丹品种群，其根皮有镇痛、解热、抗过敏、消炎、免疫等药用，具有根粗、肉厚、粉足、木心细、亮星多、久贮不变质等特色，素与白芍、菊花、茯苓并称为安徽四大名药，亦是中国34种名贵药材之一。",
		"IMGURL":require("@/assets/landmark/sign-81.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 82,
        "LOCATION": "枞阳县",
        "NAME": "枞阳媒鸭",
        "CONTENT": "原产地枞阳，羽毛青白夹杂，嘴短尾长，脚小掌红。肉质细嫩，含水量少，皮下脂肪少，有光泽；肌肉色泽鲜红，肌内丰富，纹理明显。",
		"IMGURL":require("@/assets/landmark/sign-82.jpg"),
        "USENUMBER": null
    },
    {
        "ID": 83,
        "LOCATION": "南陵县",
        "NAME": "凤丹",
        "CONTENT": "原产地铜陵，属江南牡丹品种群，其根皮有镇痛、解热、抗过敏、消炎、免疫等药用，具有根粗、肉厚、粉足、木心细、亮星多、久贮不变质等特色，素与白芍、菊花、茯苓并称为安徽四大名药，亦是中国34种名贵药材之一。",
		"IMGURL":require("@/assets/landmark/sign-81.jpg"),
        "USENUMBER": "1"
    },
    {
        "ID": 84,
        "LOCATION": "南陵县",
        "NAME": "南陵大米",
        "CONTENT": "南陵大米，安徽省南陵县特产。南陵县素有“芜湖米市，南陵粮仓”的美称，被誉为“江南鱼米之乡”“江南粮仓”。是中国四大米市之一“芜湖米市”的主要产粮区。南陵大米，以“外观品质好，光泽度佳，胶稠底轻，气味清香”等特点闻名。",
		"IMGURL":require("@/assets/landmark/sign-84.png"),
        "USENUMBER": null
    }
]